import Icon from '../components/Icon.vue'

Icon.register({"female":{"width":256,"height":512,"paths":[{"d":"M128 0C163.3 0 192 28.7 192 64S163.3 128 128 128C92.7 128 64 99.3 64 64S92.7 0 128 0M247.3 354.2L199.3 162.2A24-24 0 0 1 176 144H164.6C141.9 154.4 115 154.9 91.4 144H80A24-24 0 0 1 56.7 162.2L8.7 354.2C4.9 369.3 16.4 384 32 384H88V488C88 501.3 98.7 512 112 512H144C157.3 512 168 501.3 168 488V384H224C239.6 384 251.1 369.3 247.3 354.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/female.js
// module id = XhEk
// module chunks = 0